import advertisementsSlice from './slice';

export const { setShouldShowAdOnNewSession, flagShouldShowAd, advertisementWatched } = advertisementsSlice.actions;
